// extracted by mini-css-extract-plugin
export var change = "_45-1";
export var changeList = "_45-0";
export var changePath = "_45-2";
export var diffArrow = "_45-5";
export var diffRow = "_45-3";
export var diffValue = "_45-4";
export var error = "_45-8";
export var notice = "_45-9";
export var result = "_45-6";
export var success = "_45-7";